import React from 'react'
import styled from 'styled-components'
import { addError } from 'utils/datadog'
import isProd from 'utils/isProd'

const ErrorWrapper = styled.div`
  display: grid;
  place-items: center;
  color: white;
`

class ErrorBoundary extends React.Component<{ children: React.ReactNode }, { error?: any }> {
  constructor(props) {
    super(props)
    this.state = {}
  }

  static getDerivedStateFromError(error: any) {
    return { error }
  }

  // Stolen from https://github.com/DataDog/rum-react-integration-examples ErrorBoundary
  componentDidCatch(error: Error) {
    addError(
      error,
      {
        scope: 'error-boundary'
      },
      'source'
    )
  }

  render() {
    const { error } = this.state

    if (error) {
      return (
        <ErrorWrapper>
          <h1>Something went wrong</h1>
          <p>Please try again later. If this error persists please contact support.</p>
          {!isProd() ? (
            <>
              <small>
                {error.name} - {error.message}
              </small>
              <pre>{error.stack}</pre>
            </>
          ) : null}
        </ErrorWrapper>
      )
    }

    return this.props.children
  }
}

export default ErrorBoundary
